import { connect } from "react-redux";
import DealerWalletListing from "./Listing";
import { bindActionCreators } from "redux";
import {walletListingDealer} from "../../../../services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    listing : state.Wallet.dealerPaymentRequests,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        walletListingDealer
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DealerWalletListing);